<i *ngIf="theme === 'dark-theme' || theme === 'light2-theme'"
	class="{{ theme }} fa-square-o"
	[class.fa]="(!useExclude || !checked) && !(theme === 'dark-theme' && checked)"
	[class.fas]="theme === 'dark-theme' && checked"
	[class.fa-solid]="checked && !partial && useExclude"
	[class.fa-square-o]="!checked && !partial"
	[class.fa-check-square]="checked && !partial && !useExclude"
	[class.fa-times-square]="checked && !partial && useExclude"
	[class.fa-minus-square]="partial"
	[style.color]="(useExclude && checked && '#3f536e') || (!checked && falseColor) || color || null"
></i>
<i *ngIf="!theme || theme === 'rb'"
	class="fa fa-check"
	[class.checked]="checked"
	[class.disabled]="disabled"
	[hidden]="!checked"
	[style.color]="color || null"
></i>
